var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPawSample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0017 10.2C13.3965 10.2 14.5272 8.58823 14.5272 6.6C14.5272 4.61177 13.3965 3 12.0017 3C10.6069 3 9.4762 4.61177 9.4762 6.6C9.4762 8.58823 10.6069 10.2 12.0017 10.2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2269 20.5738C17.2311 21.1377 18.7364 21.5613 18.7364 18.9828C18.7364 15.1263 15.7212 12 12.0017 12C8.28228 12 5.26709 15.1263 5.26709 18.9828C5.26709 21.5613 6.77237 21.1377 8.77651 20.5738C9.76988 20.2943 10.8858 19.9803 12.0017 19.9803C13.1177 19.9803 14.2336 20.2943 15.2269 20.5738Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94739 7.05012C7.87725 8.77197 7.65184 10.7722 6.44392 11.5178C5.23599 12.2633 3.50298 11.4719 2.57312 9.75012C1.64326 8.02827 1.86868 6.02801 3.0766 5.28243C4.28452 4.53684 6.01754 5.32827 6.94739 7.05012Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5561 11.5178C16.3482 10.7722 16.1228 8.77197 17.0526 7.05012C17.9825 5.32827 19.7155 4.53684 20.9234 5.28243C22.1313 6.02801 22.3567 8.02827 21.4269 9.75012C20.497 11.4719 18.764 12.2633 17.5561 11.5178Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPawSample);
export default __webpack_public_path__ + "static/media/paw-sample.d15d55a049e0c4e1a4ba69890548e3fe.svg";
export { ForwardRef as ReactComponent };